import instance from '@apis/instance';
import {
  ProjectResponse,
  ProjectsResponse,
  TestShopResponse,
} from '@models/project';

class ProjectApi {
  static getProjects(): Promise<ProjectsResponse> {
    return instance.get('/projects');
  }

  static getProject(): Promise<ProjectResponse> {
    return instance.get('/project');
  }

  static getTestShops(): Promise<TestShopResponse> {
    return instance.get('/project/test-shops');
  }
}

export default ProjectApi;
